import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface HeaderCellProps {
  align?: 'center' | 'left' | 'right';
  value?: string;
  type?: 'actions' | 'default';
}

const HeaderCell = styled.th<HeaderCellProps>`
  position: relative;
  padding: 0 ${toRem(22)};
  font-family: ${theme.font.family.euclid};
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${toRem(11)};
  line-height: 100%;
  text-align: left;
  white-space: nowrap;
  color: ${theme.color.neutral[900]};
  border-bottom: ${toRem(1)} solid ${theme.color.neutral[200]};

  ${({ align }) =>
    align === 'center' &&
    css`
      text-align: center;

      > * {
        margin: 0 auto;
      }
    `}

  ${({ align }) =>
    align === 'right' &&
    css`
      justify-content: flex-end;
      text-align: right;

      > * {
        margin: 0 0 0 auto;
      }
    `}

  ${({ type }) =>
    type === 'actions' &&
    css`
      width: ${toRem(33)};
    `}
`;

export default HeaderCell;
